import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const PlusIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
        >
            <path
                className={fillStyles}
                transform="translate(-1558 -236) translate(1494 14) translate(48 206) translate(16 16)"
                d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 5.5c-.276 0-.5.224-.5.5v5.5H6c-.276 0-.5.224-.5.5s.224.5.5.5h5.5V18c0 .276.224.5.5.5s.5-.224.5-.5v-5.5H18c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-5.5V6c0-.276-.224-.5-.5-.5z"
            />
        </svg>
    );
};
